import {
  SurveyResponsesView,
  SurveysListView,
  SurveyResultsView,
  SurveyPerformanceView,
} from '@hotjar/feedback';
import { Route } from 'react-router-dom';
import {
  SiteAccessRequiredRoute,
  NoInterfaceNgApp,
  ErrorBoundaryRoute,
  WithAppInterfaceRoute,
} from '@hotjar/webapp-routing';
import { WithGettingStartedSideBar } from '@hotjar/webapp/features/Activation/GetStartedGuide';
import { SURVEYS } from '@hotjar/webapp/constants/routes';
import { RedirectWithCurrentParams } from '@hotjar/webapp/utils/routing';
import { useMergedSurveyViewExperiment } from '@hotjar/feedback/components/Surveys/hooks/useMergedSurveyViewExperiment';

const SurveysList = () => {
  return (
    <SiteAccessRequiredRoute>
      <ErrorBoundaryRoute squadSentryTag="feedback" featureName="surveys.list">
        <WithGettingStartedSideBar>
          <SurveysListView />
        </WithGettingStartedSideBar>
      </ErrorBoundaryRoute>
    </SiteAccessRequiredRoute>
  );
};

const SurveyResponses = () => {
  return (
    <SiteAccessRequiredRoute>
      <ErrorBoundaryRoute squadSentryTag="feedback" featureName="surveys.responses.view">
        <WithAppInterfaceRoute>
          <WithGettingStartedSideBar>
            <SurveyResponsesView />
          </WithGettingStartedSideBar>
        </WithAppInterfaceRoute>
      </ErrorBoundaryRoute>
    </SiteAccessRequiredRoute>
  );
};

const SurveyResults = () => {
  return (
    <SiteAccessRequiredRoute>
      <ErrorBoundaryRoute squadSentryTag="feedback" featureName="surveys.results.view">
        <WithAppInterfaceRoute>
          <WithGettingStartedSideBar>
            <SurveyResultsView />
          </WithGettingStartedSideBar>
        </WithAppInterfaceRoute>
      </ErrorBoundaryRoute>
    </SiteAccessRequiredRoute>
  );
};

const SurveyPerformance = () => {
  return (
    <SiteAccessRequiredRoute>
      <ErrorBoundaryRoute squadSentryTag="feedback" featureName="surveys.performance.view">
        <WithAppInterfaceRoute>
          <WithGettingStartedSideBar>
            <SurveyPerformanceView />
          </WithGettingStartedSideBar>
        </WithAppInterfaceRoute>
      </ErrorBoundaryRoute>
    </SiteAccessRequiredRoute>
  );
};

export const SurveyRoutes = (): JSX.Element => {
  const isInMergedViewExperiment = useMergedSurveyViewExperiment();

  return (
    <>
      <Route
        path={SURVEYS.BASE.path}
        element={<RedirectWithCurrentParams to={SURVEYS.RESPONSES_DEFAULT.path} />}
      />

      <Route path={SURVEYS.LIST.path} element={<SurveysList />} />

      <Route path={SURVEYS.RESPONSES.path} element={<SurveyResponses />} />
      <Route path={SURVEYS.RESPONSES_DEFAULT.path} element={<SurveyResponses />} />

      {!isInMergedViewExperiment && (
        <>
          <Route path={SURVEYS.RESULTS.path} element={<SurveyResults />} />
          <Route path={SURVEYS.RESULTS_DEFAULT.path} element={<SurveyResults />} />
        </>
      )}

      {isInMergedViewExperiment && (
        <>
          <Route path={SURVEYS.RESULTS.path} element={<SurveyResponses />} />
          <Route path={SURVEYS.RESULTS_DEFAULT.path} element={<SurveyResponses />} />
        </>
      )}

      <Route path={SURVEYS.PERFORMANCE.path} element={<SurveyPerformance />} />
      <Route path={SURVEYS.PERFORMANCE_DEFAULT.path} element={<SurveyPerformance />} />

      <Route path={SURVEYS.CREATE_BASE.path} element={<NoInterfaceNgApp />} />
      <Route path={SURVEYS.CREATE.path} element={<NoInterfaceNgApp />} />

      <Route path={SURVEYS.EDIT.path} element={<NoInterfaceNgApp />} />
      <Route path={SURVEYS.EDIT_BASE.path} element={<NoInterfaceNgApp />} />
    </>
  );
};
